(function () {
  if (window.LpNovaCapsulasVitrine) return;
  window.LpNovaCapsulasVitrine = true;

  function init(root) {
    if (!root || root.dataset.lpQtdReady === "true") return;
    root.dataset.lpQtdReady = "true";
    root.querySelectorAll("[data-lp-qtd]").forEach(function (button) {
      button.addEventListener("click", function () {
        var field = button.parentElement.querySelector("input");
        if (!field || field.disabled) return;
        var step = Number(button.getAttribute("data-lp-qtd"));
        var next = Math.max(1, (Number(field.value) || 1) + step);
        field.value = String(next);
      });
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll(".lp-nova-capsulas-vitrine").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
